import React, { useEffect, useState } from "react";
import "./Header.css";
import AuthModal from "./AuthModal";
import { Link } from "react-router-dom";
import { auth } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";

function Header() {
  const [authModal, setAuthModal] = useState({ isOpen: false, mode: "login" });
  const [user, setUser]           = useState(null);
  const [menuOpen, setMenuOpen]   = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  const openAuthModal  = (mode) => setAuthModal({ isOpen: true, mode });
  const closeAuthModal = () => setAuthModal({ isOpen: false, mode: "login" });
  const handleSignOut  = async () => { await signOut(auth); setMenuOpen(false); };

  const initial = (user?.displayName || user?.email || "U").trim().charAt(0).toUpperCase();

  return (
    <>
      <header className="header">
        <div className="logo">
          <img src="/headerlogo.png" alt="NYLeads" style={{ width: 28, height: 28, borderRadius: 4 }} />
          NYleadflow
        </div>

        
        <div className="auth-buttons">
          {user ? (
            <div className="header-profile" onMouseEnter={() => setMenuOpen(true)} onMouseLeave={() => setMenuOpen(false)}>
              <div className="user-avatar">{initial}</div>
              {menuOpen && (
                <div className="header-dropdown">
                  <div className="header-dropdown-email">{user.email}</div>
                  <div className="header-dropdown-divider" />
                  <button className="header-dropdown-signout" onClick={handleSignOut}>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <button onClick={() => openAuthModal("login")} className="login-btn">Log In</button>
              <button onClick={() => openAuthModal("signup")} className="signup-btn">Sign Up</button>
            </>
          )}
        </div>
      </header>

      <AuthModal
        isOpen={authModal.isOpen}
        onClose={closeAuthModal}
        mode={authModal.mode}
        onSwitchMode={(mode) => setAuthModal({ isOpen: true, mode })}
      />
    </>
  );
}

export default Header;